module.exports = __webpack_public_path__ + "media/images/mobile/Slider5-3b467ca66646ae1cb483a1d43f43c7bc.png";